import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  PaginatedVacationBonusDocument,
  AddVacationBonusMutation,
  AddVacationBonusMutationVariables,
  AddVacationBonusDocument,
} from "@/graphql/__generated__/graphql";
import { resetPaginationField } from "@/store/paginationStore";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

/**
 * Custom hook for creating a vacation bonus and handling the necessary cache updates.
 * @returns {Object} - Contains the createVacationBonusMutation function, loading state, and error state.
 */
export default function useAddVacationBonusMutationHook(): { addVacationBonusMutation: any, loading: any, error: any } {
  const { t } = useTranslation(["toasts"]);

  const [addVacationBonusMutation, { loading, error }] = useMutation<AddVacationBonusMutation, AddVacationBonusMutationVariables>(
    AddVacationBonusDocument, {
      onCompleted: () => {
      // Reset pagination to first page to avoid cache inconsistencies
        resetPaginationField("paginatedVacationBonus");

        toast(CustomToastComponent, {
          toastId: "vacation-bonus-added-success",
          data: {
            title: t("toasts.vacationbonusaddedsuccessfully"),
            type: "success"
          }
        });
      },
      refetchQueries: [
        {
          query: PaginatedVacationBonusDocument,
          variables: {
            first: 10,
            currentPage: 0,
            after: null,
            filters: {
              activeFrom: null,
              bonusAbsolute: null,
              bonusRelative: null,
              provinces: null
            },
            sort: null
          }
        }
      ]
    });

  return {
    addVacationBonusMutation,
    loading,
    error
  };
}
